module.exports = {"TXTCLI_Top_Prize_1":{"id":"TXTCLI_Top_Prize_1","defaultMessage":"Primer premio"}}